import React, { useCallback, useEffect, useState } from 'react';

import { Icons, PageTitle, UnavailableFeatureMessage } from '@components/common';
import ProfileTabSection from '@components/common/ProfileTabSection';

import { useVendorDrivenFeatureAvailability } from '@hooks/utils/useVendorDrivenFeatureAvailability';
import { useWindowHeight } from '@hooks/utils/useWindowHeight';

import { configurationManagement } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { EAdminPanelPageTitles } from '@enums/common';

import { dataSourcesTabsNames } from './constants';

import DataSourceGNBConfigurationTable from './DataSourceGNBConfigurationTable';
import { getDataSourcesTabs } from './utils';

import styles from './DataSources.module.scss';

const OFFSET_HEIGHT = 175;

const DataSources = () => {
	const { selectedVendor } = useAppSelector(configurationManagement);

	const [currentTab, setCurrentTab] = useState(dataSourcesTabsNames.gnb);
	const [maxHeight, setMaxHeight] = useState('');

	const tabs = getDataSourcesTabs();

	const getCurrentTab = useCallback(() => {
		switch (currentTab) {
			case dataSourcesTabsNames.gnb:
				return <DataSourceGNBConfigurationTable />;
			default:
				return <DataSourceGNBConfigurationTable />;
		}
	}, [currentTab]);

	const windowHeight = useWindowHeight();

	useEffect(() => {
		const maxHeight = windowHeight - OFFSET_HEIGHT;

		setMaxHeight(`${maxHeight}px`);
	}, [windowHeight]);

	const isFeatureAvailable = useVendorDrivenFeatureAvailability();

	return isFeatureAvailable ? (
		<div className={styles.container}>
			<PageTitle
				icon={Icons.configurationIcon()}
				title={EAdminPanelPageTitles.DataSources}
			/>
			<ProfileTabSection
				currentTab={currentTab}
				getCurrentTab={getCurrentTab}
				maxHeight={maxHeight}
				setCurrentTab={setCurrentTab}
				tabs={tabs}
			/>
		</div>
	) : <UnavailableFeatureMessage vendorName={selectedVendor?.value} />;
};

export default DataSources;
